import React, { FC, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { DataGrid } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { RowDblClickEvent } from 'devextreme/ui/data_grid';
import { useDataSource } from 'utils/create-data-souce-instance';
import $createStore from 'utils/create-store-instance';

import { NomenclatureTransfer } from 'bus/nomenclatureTransfer/types';

import { NomenclatureTransferListPage, NomenclatureTransferModalRemove } from '../components';

export const NomenclatureTransferListScreen: FC = () => {
  const history = useHistory();

  const ref = useRef<DataGrid>(null);

  const [visibleRemove, setVisibleRemove] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const dataSourceNomenclatureTransferList = useDataSource('/v1/NomenclatureTransfer', 'id');
  const materialDateSource = useMemo(() => {
    return $createStore('/v1/Material', 'id');
  }, []);

  const unitDataSource = useMemo(() => {
    return $createStore('/v1/unit', 'id', { pageSize: 20, paginate: true });
  }, []);

  const handleRefreshList = () => {
    ref.current?.instance.refresh();
  };

  const handleAdd = () => {
    history.push('/nomenclature-transfer-add');
  };

  const handleRowDblClick = (row: RowDblClickEvent<NomenclatureTransfer>) => {
    history.push(`/nomenclature-transfer/${row.data.id}`);
  };

  const handleClickEdit = (id: number) => {
    history.push(`/nomenclature-transfer/${id}`);
  };

  const handleClickRemove = (id: number) => {
    setSelectedId(id);
    setVisibleRemove(true);
  };

  return (
    <>
      <NomenclatureTransferModalRemove
        id={selectedId}
        changeVisible={setVisibleRemove}
        refresh={handleRefreshList}
        visible={visibleRemove}
      />
      <NomenclatureTransferListPage
        onAdd={handleAdd}
        onRefreshList={handleRefreshList}
        onRowDblClick={handleRowDblClick}
        onClickEdit={handleClickEdit}
        onClickRemove={handleClickRemove}
        ref={ref}
        dataSourceNomenclatureTransferList={dataSourceNomenclatureTransferList}
        storeMaterial={materialDateSource}
        unitDataSource={unitDataSource}
      />
    </>
  );
};
